// export const combinedVisits = true;
// export const productStatement = true;
// export const dailyReport = true
// export const employeeStock = true
// export const pricesTypes = true
// export const vacations = true;

/* Ibn-alhaytham */
// export const combinedVisits = true;
// export const productStatement = false;
// export const dailyReport = false
// export const employeeStock = false
// export const pricesTypes = false
// export const vacations = false;

/* Oubari */
// export const combinedVisits = true;
// export const productStatement = false;
// export const dailyReport = true
// export const employeeStock = false
// export const pricesTypes = false
// export const vacations = false

/* Mirta - Oulabi */
// export const combinedVisits = true;
// export const productStatement = false;
// export const dailyReport = false
// export const employeeStock = true
// export const pricesTypes = true
// export const vacations = false

// /* alkhalil */
export const combinedVisits = true;
export const productStatement = false;
export const dailyReport = false
export const employeeStock = false
export const pricesTypes = false
export const vacations = false;